import * as echarts from 'echarts';
import moment from 'moment';
import Swal from 'sweetalert2';


import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheUpServerGet, callTheUpServerPost } from './helpers/axiosHelper';
import { hydrateUserBasicData } from './helpers/basicHelper';
import { addDNoneClass, byId, convertToInt, convertToTwoDecimalInt, Toast } from './helpers/utility';

authHelper.validate().then(async () => {
    try {
        await hydrateUserBasicData();






        const yamasha_stock_price_display = byId('yamasha_stock_price_display');

        const yamasha_stock_price_display1 = byId('yamasha_stock_price_display1');
        const yamasha_stock_gain_display1 = byId('yamasha_stock_gain_display1');
        const yamasha_stock_gain_in_percent_display1 = byId('yamasha_stock_gain_in_percent_display1');
        const priceChangeTextDiv = byId('priceChangeTextDiv');


        const stock_quantity_input = byId('stock_quantity_input');
        const popupDiv = byId('popupDiv');
      
        const lot_quantity_input = byId('lot_quantity_input');
        const data_table_body = byId('data_table_body');


        const yamashaVentureStockPageFun = {
            fetch: {
                price: async () => {
                    try {

                        const response = await callTheUpServerGet('/basic/getYamashaVentureStockPrice');
                        axiosResponseHandler(response);
                        const res = response.data;
                        if (res.status === 'success') {
                            console.log(res);
                            const { yvsStockCurrentPrice, priceChange, priceChangePercent } = res.yamashaVentureStockPriceData;
                            yamasha_stock_price_display1.innerHTML = `₹ ${yvsStockCurrentPrice}`;
                            yamasha_stock_price_display.value = yvsStockCurrentPrice;
                            yamasha_stock_gain_display1.innerHTML = `${(priceChange > 0) ? '+' : ''}${priceChange}`;

                            yamasha_stock_gain_in_percent_display1.innerHTML = `( ${(priceChangePercent > 0) ? '+' : ''}${priceChangePercent} % )`;
                            const priceChangeTextClass = (priceChange > 0) ? 'text-success' : 'text-danger';

                            priceChangeTextDiv.classList.add(priceChangeTextClass);

                        }


                    } catch (error) {
                        axiosErrorHandler(error);
                    }
                },
                ordersData: async (skip) => {
                    try {
                        skip = skip || 0;
                        const response = await callTheUpServerGet(`/basic/getYamashaVentureStockOrders/${skip}`);
                        axiosResponseHandler(response);
                        const res = response.data;
                        if (res.status === 'success') {
                            console.log(res);
                            if (skip === 0) {
                                data_table_body.innerHTML = ``;
                            }
                            if (res.ordersData.length > 0) {

                                for (let i = 0; i < res.ordersData.length; i++) {

                                    const { transactionType, quantity, atPrice, createdAt } = res.ordersData[i];

                                    const date = moment(createdAt * 1000).format('DD/MM/YYYY');
                                    const time = moment(createdAt * 1000).format('LT');

                                    const after_year_date = moment(createdAt * 1000).add(1, 'y');

                                    const lock_in_time = after_year_date.format('DD/MM/YYYY');

                                    data_table_body.innerHTML += `
                    <tr class="text-light">
                        <td>${date}  ${time}</td>
                      
                        <td>${quantity}</td>
                        <td>${transactionType}</td>
                        <td>₹${atPrice}</td>
                        <td>${lock_in_time}</td>
                    
                    
                    
                    
                    
                    
                    </tr>`;



                                }

                            } else {
                                data_table_body.innerHTML += `<tr class="table-line">
                            <th scope="row" col='5'>
                                <p>No Profit gain Till Now</p>
                            </th>
                        
                        </tr>`;
                            }


                        }
                    } catch (error) {
                        axiosErrorHandler(error);
                    }
                },
                portfolioData: async () => {
                    try {

                        const response = await callTheUpServerGet('/basic/getPortfolioData');
                        axiosResponseHandler(response);
                        const res = response.data;
                        if (res.status === 'success') {
                            console.log(res);
                            const { yamashaStocksQuantity, yamashaStocksInvestment, yamashaStocksAveragePrice, stocksCurrentValue, gainOrLoss } = res.portfolioData;


                            const portfolio_data_table_body = byId('portfolio_data_table_body');



                            const text_color = (gainOrLoss > 0) ? 'green' : 'red';


                            portfolio_data_table_body.innerHTML = `
                   <tr class="text-light">
                   <td>YAMASHA VENTURE LTD</td>
                   <td>${yamashaStocksQuantity}</td>
                   <td>₹${yamashaStocksAveragePrice}</td>
                   <td>₹${yamashaStocksInvestment}</td>
                   <td>₹${stocksCurrentValue}</td>
                   <td class="text-${text_color}">₹${gainOrLoss}</td>
                   </tr> `;

                            byId('cur_val_display').innerHTML = `₹${stocksCurrentValue}`;


                        }


                    } catch (error) {
                        axiosErrorHandler(error);
                    }
                },
                graphData: async () => {
                    try {

                        const response = await callTheUpServerGet('/basic/getYamashaVentureStockGraph');
                        axiosResponseHandler(response);
                        const res = response.data;
                        if (res.status === 'success') {
                            console.log(res);
                            const { graphData, yamashaVentureStockPrice } = res;
                            


                            // adding data to table
                            let i = 0;
                            const data = [];
                            while (graphData.length > i) {
                                const { price , createdAt} = res.graphData[i];

                                data.push([createdAt * 1000, price]);


                                i++;
                            }
                            data.push([+ new Date(), yamashaVentureStockPrice]);

                            // graph code 
                            var chartDom = document.getElementById('graph_main_div');
                            var myChart = echarts.init(chartDom);
                            var option;



                            console.log(data);
                            option = {

                                tooltip: {
                                    trigger: 'axis',
                                    position: function (pt) {
                                        return [pt[0], '10%'];
                                    },
                                    // axisPointer: {
                                    //     type: 'cross'
                                    //   }
                                },
                                title: {
                                    left: 'center',
                                    text: 'Yamasha stock price history'
                                },
                                toolbox: {
                                    feature: {
                                        // dataZoom: {
                                        //     yAxisIndex: 'none'
                                        // },
                                        // restore: {},
                                        saveAsImage: {}
                                    }
                                },
                                xAxis: {
                                    type: 'time',
                                    boundaryGap: false,
                                    axisLabel: {
                                        // formatter: '{dd}/{MM}/{yyyy} {hh}:{mm}'
                                        interval: 'auto'
                                    }
                                },
                                yAxis: {
                                    type: 'value',
                                    boundaryGap: [0, '50%']
                                },
                                dataZoom: [
                                    {
                                        type: 'inside',
                                        start: 50,
                                        end: 100
                                    },
                                    {
                                        start: 80,
                                        end: 100
                                    }
                                ],
                                series: [
                                    {
                                        name: 'Price',
                                        type: 'line',
                                        smooth: false,
                                        symbol: 'circle',
                                        areaStyle: {},
                                        data: data
                                    }
                                ]
                            };

                            option && myChart.setOption(option);

                        }


                    } catch (error) {
                        axiosErrorHandler(error);
                    }
                },



            },
            action: {
                buy: {
                    calculate: () => {
                        let lotQuantity = convertToTwoDecimalInt(lot_quantity_input.value);



                        if (lotQuantity <= 0 || isNaN(lotQuantity)) {
                            lot_quantity_input.value = lotQuantity = 0;
                        }


                        const stocksQuantity = convertToInt(lotQuantity * 1000);

                        stock_quantity_input.value = stocksQuantity;

                        // adding more data 

                        const yamasha_stock_total_amount = byId('yamasha_stock_total_amount');
                        const totalAmount = convertToTwoDecimalInt(stocksQuantity * yamasha_stock_price_display.value);
                        // tAmount = Math.round(tAmount * 100) / 100;
                        yamasha_stock_total_amount.value = totalAmount;
                    },
                    init: (status) => {

                        // console.log('test', status);
                        if (status) {
                            addDNoneClass(popupDiv, false);
                            yamashaVentureStockPageFun.action.buy.calculate();

                        } else {
                            addDNoneClass(popupDiv, true);
                        }

                    },
                    submit: async () => {
                        try {
                            if (stock_quantity_input.value < 1) {
                                Toast.fire({
                                    icon: 'error',
                                    title: 'stocks quantity must be more than 1'
                                });
                                return;
                            }
                            const data = {
                                stocksQuantity: stock_quantity_input.value
                            };
                            const response = await callTheUpServerPost('/basic/buyYamashaVentureStock', { data });
                            axiosResponseHandler(response);
                            const res = response.data;
                            if (res.status === 'success') {
                                console.log(res);
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Purchased Complete',

                                });
                                yamashaVentureStockPageFun.action.buy.init(false);
                                yamashaVentureStockPageFun.fetch.price();
                                yamashaVentureStockPageFun.fetch.ordersData();
                                yamashaVentureStockPageFun.fetch.portfolioData();

                            }


                        } catch (error) {
                            axiosErrorHandler(error);
                        }
                    }
                },
                sell:{
                    init:() => {
                        // console.log('success');
                        Swal.fire({
                            title: "You can't sell stock",
                            text: "You can't sell due to lock-in period  of 1 Year",
                            icon: 'warning'
            
                        });
                    }
                },
                showOrdersHistory : () => {
                    const history_div = byId('history-show');
                    const show_button = byId('show_button');
                    const hide_button = byId('hide_button');
                    addDNoneClass(show_button, true);
                    addDNoneClass(hide_button, false);
                    addDNoneClass(history_div, false);
                },
                hideOrdersHistory :() => {
                    const hide_button = byId('hide_button');
                    const history_div = byId('history-show');
                    const show_button = byId('show_button');
        
                    addDNoneClass(hide_button, true);
                    addDNoneClass(history_div, true);
                    addDNoneClass(show_button, false);
        
                }
            }

        };

        window.yamashaVentureStockPageFun = yamashaVentureStockPageFun;

        yamashaVentureStockPageFun.fetch.price();
        yamashaVentureStockPageFun.fetch.ordersData();
        yamashaVentureStockPageFun.fetch.portfolioData();
        yamashaVentureStockPageFun.fetch.graphData();









  

      
      
       

    } catch (error) {
        console.log(error);
    }


});





